import { AccordionDivider } from "./divider";
import { AccordionHeader } from "./header";
import { AccordionRoot } from "./root";

export const AccordionStep = {
  Root: AccordionRoot,
  Header: AccordionHeader,
  Divider: AccordionDivider,
};
